import type { SVGProps } from 'react';

/**
 * Ikona 3D krychličky ve stylu ikon @tmapy/style-guide (viewBox 24, jeden path,
 * bez fill/stroke – ty dodává komponenta Icon přes CSS: stroke currentColor,
 * 2px, round). Lokální doplněk, protože SG odpovídající ikonu nemá.
 */
export const Svg3d = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 24 24'
    focusable='false'
    {...props}
  >
    <path d='M12 3 20.5 7.5v9L12 21l-8.5-4.5v-9z M3.5 7.5 12 12l8.5-4.5M12 12v9' />
  </svg>
);
